import { render } from "./StandardDeviationChart.vue?vue&type=template&id=18ffd767&scoped=true"
import script from "./StandardDeviationChart.vue?vue&type=script&lang=js"
export * from "./StandardDeviationChart.vue?vue&type=script&lang=js"

import "./StandardDeviationChart.vue?vue&type=style&index=0&id=18ffd767&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ffd767"]])

export default __exports__